export default __webpack_public_path__ + "static/profit-0b62657f5f1c7edd31875d3d19ecaccf.jpg";